import LocalizedStrings from 'localized-strings';

export default new LocalizedStrings({
  en: {
    dirty: 'Resend download link',
    pristine: 'Receive a download link',
    sending: 'It may take a few seconds to arrive...',
  },
  fr: {
    dirty: 'Envoyer de nouveau un lien de téléchargement',
    pristine: 'Recevoir un lien de téléchargement',
    sending: "L'envoi peut prendre quelques secondes...",
  },
} as const);
